export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.87 6l-4.15 4.15-.72.71-.73-.71L4.13 8c-.2-.19-.2-.52 0-.71.2-.2.52-.2.72 0L7 9.42l4.15-4.13c.2-.2.53-.2.73 0 .2.2.19.52-.01.71z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};